import { useContext, useEffect, useState } from 'react'
import { KeycloakService } from '@nv/auth'
import { KeycloakAdminService } from '@nv/auth'
import { useSessionTimer } from '@nv/contexts'
import { LoginFlowContext } from '@nv/contexts'
import { AdminVoterAuthService } from '@nv/services'
import { VoterAuthService } from '@nv/services'
import { beforeUnload } from '@nv/utils'
import { DateTime } from 'luxon'
import { useNavigate } from 'react-router-dom'

const REMAINING_TIME_WARN_MINS = 1

export function useKeycloakSessionTime(maxTime) {
  const navigate = useNavigate()
  const LOGIN_CONTEXT = useContext(LoginFlowContext)

  const admin = window.location.pathname?.startsWith('/admin') ? true : false
  const KcService = admin ? KeycloakAdminService : KeycloakService

  const onSessionExpired = async () => {
    try {
      window.removeEventListener('beforeunload', beforeUnload)
      if (!admin) {
        await VoterAuthService.logOut(navigate)
        LOGIN_CONTEXT.setLoginFlow('Login')
      } else {
        await AdminVoterAuthService.logOut(navigate)
        LOGIN_CONTEXT.setLoginFlow('Admin Login')
      }
    } catch (error) {
      /* empty */
    }
  }

  const [sessionTimeRemaining, setSessionTimeRemaining] = useState(null)
  const { setSessionEnding } = useSessionTimer()

  const getSessionTimeRemaining = async () => {
    try {
      if (!KcService.getSessionStartTime()) onSessionExpired()
      else {
        const sessionEndTime = DateTime.fromSeconds(KcService.getSessionStartTime()).plus({ minutes: maxTime })
        const sessionEndTimeDiff = sessionEndTime.diffNow(['hours', 'seconds', 'minutes', 'milliseconds'])

        const hoursLeft = sessionEndTimeDiff.get('hours')
        const minutesLeft = sessionEndTimeDiff.get('minutes')
        const secondsLeft = sessionEndTimeDiff.get('seconds')

        const formattedSecs = String(secondsLeft).padStart(2, '0')

        setSessionTimeRemaining({ minutes: minutesLeft, seconds: formattedSecs, hours: hoursLeft })

        if (admin && hoursLeft === 0 && minutesLeft === REMAINING_TIME_WARN_MINS && secondsLeft === 0) {
          window.removeEventListener('beforeunload', beforeUnload)
          setSessionEnding(true)
        }

        if (sessionEndTimeDiff <= 0) {
          onSessionExpired()
        }
      }
    } catch (error) {
      /* empty */
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      getSessionTimeRemaining()
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return sessionTimeRemaining
}
